const getId:(navigation_label: string, type: string) => string = (navigation_label, type) => {
  const label = navigation_label?.toLowerCase().split(" ").join("") || "";
  return `${label}_${type}`;
}

export default getId;
